// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (plants-edit e plants-list)

import { Injectable } from '@angular/core';
import { Plants } from './plants.model';
import { Subject } from 'rxjs';

@Injectable()
export class PlantsService {
  private plants: Plants[] = [];
  plantsChanged = new Subject<Plants[]>();
  plantsEditMode = new Subject<number>();
  public plant: Plants
  plantsId
  public refresh = new Subject<any>();
  refresh$ = this.refresh.asObservable();

  constructor( 
  ) { }

  // metodo richiamato alla modifica di un pannello; viene identificata la posizione nella tabella dell'elemento da aggiornare
  editPlants(plantsId: number) {
    this.plantsId = plantsId
    this.plant = this.getPlantsByIndex(plantsId)
    this.plantsEditMode.next(plantsId);
  }

  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setPlants(plants: Plants[]) {
    if (plants !== null) {
      this.plants = plants;
      this.plantsChanged.next(this.plants.slice());
    }
  }

  // metodo che restituisce l'intero oggetto "pannello" in base alla posizione nella tabella
  getPlantsByIndex(id: number) {
    return this.plants.find(x => x.id === id);
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getPlants() {
    return this.plants;
  }

  // metodo che inserisce il nuovo pannello appena inserito nell'array locale contenente tutti i pannelli, aggiornando la tabella
  addPlants(plants: Plants) {
    plants.id = this.plants.length;
    this.plants.push(plants);
    this.plantsChanged.next(this.plants.slice());
  }

  // metodo che aggiorna il pannello appena modificato nell'array locale contenente tutti i pannelli, aggiornando la tabella
  updatePlants(index: number, plants: Plants) {
    this.plants[index] = plants;
    this.plantsChanged.next(this.plants.slice());
  }

  // metodo che individua la posizione del pannello appena cancellato, aggiorna la tabella e l'array locale contenente tutti i pannelli
  deletePlants(id) {
    var elementPos = this.plants.map(function (x) { return x.id; }).indexOf(id);
    this.plants.splice(elementPos, 1);
    this.plantsChanged.next(this.plants.slice());
  }
}
